import { render, staticRenderFns } from "./RoofCalTitleDes.vue?vue&type=template&id=4fea9480&scoped=true"
import script from "./RoofCalTitleDes.vue?vue&type=script&lang=js"
export * from "./RoofCalTitleDes.vue?vue&type=script&lang=js"
import style0 from "./RoofCalTitleDes.vue?vue&type=style&index=0&id=4fea9480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea9480",
  null
  
)

export default component.exports